module.exports = __webpack_public_path__ + "static/media/charity-1.2f57f20e.png";